import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-receiving-export-produts-to-shipping',
  templateUrl: './receiving-export-produts-to-shipping.component.html',
  styleUrls: ['./receiving-export-produts-to-shipping.component.css']
})
export class ReceivingExportProdutsToShippingComponent implements OnInit {
  PlaceOrderStatusDescripcion = []
  arrayDescripionRouting = []
  labelResponse = ''
  formExport: FormGroup
  constructor (
    public http: HttpClient,
    public formbuilder: FormBuilder,
    public auten: AuthenticationService,
    public dialogRef: MatDialogRef<ReceivingExportProdutsToShippingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.PlaceOrderStatusDescripcion = []
    this.arrayDescripionRouting = []
  }

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {
    this.formExport = this.formbuilder.group({
      idorder: [0],
      estatus: [''],
      route: [''],
      po: [''],
      references: [''],
      customerId: [0]
    })
    console.log(this.data)
    this.formExport.controls.idorder.setValue(Number(this.data.idorder))
    this.formExport.controls.po.setValue(String(this.data.po))
    this.formExport.controls.references.setValue(String(this.data.references))
    this.formExport.controls.customerId.setValue(Number(this.data.customerId))
    this.OnSelectStatusDescripcion()
    this.OnSelectRouting()
  }
  OnSelectRouting () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = Number(this.auten.currentUserValue.companyIdWh)
    Request['active'] = Number('1')

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/RoutingDescriptionsSelect`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arrayDescripionRouting = response
      })
  }
  OnSelectStatusDescripcion () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderStatusDescripcion`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.PlaceOrderStatusDescripcion = response
      })
  }
  filterData (locationName: string) {
    return this.PlaceOrderStatusDescripcion.filter(object => {
      if (object['value'] == locationName) {
        return object
      }
    })
  }
  OnExportreceivingtoshipping () {
    this.http
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/createshippingautobyreceiverId?receiverId=${Number(
          this.formExport.controls.idorder.value
        )}&customerId=${Number(
          this.formExport.controls.customerId.value
        )}&companyId=${Number(
          this.auten.currentUserValue.companyIdWh
        )}&CreatedByUserID=${Number(
          this.auten.currentUserValue.whId
        )}&tblCompanyStatusDescriptionID=${Number(
          this.formExport.controls.estatus.value
        )}&Routing=${Number(
          this.formExport.controls.route.value
        )}&RefNumber=${String(
          this.formExport.controls.references.value || ' '
        )}&PONumber=${String(this.formExport.controls.po.value || ' ')}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.labelResponse = String(response.responses)
        } catch (error) {}
      })
  }
}
